import React, { useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { ModalAlignmentEnum } from "@voltmoney/types";
import CustomHeader from "../../customHeader/CustomHeader";
import { Typography } from "../../typography/Typography";
import { Divider } from "../../divider/Divider";
import { Button } from "../../button/Button";
import { Icon } from "../../icon/Icon";
import { addCommasToNumber, getAutoDebitDate, getLenderIcon } from "../utils";
import BottomSheet from "../BottomSheet";
import { isMobile, isMobileView } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import TooltipComp from "../TooltipComp";
import { LENDER_ID } from "../constants";
const VerifyInterestEnhanceLimit = ({ height, triggerAction, lenderData, pledgeDetails, autoDebitDate, continueAction, needHelpAction, goBackAction, loanExpireDateToShow, openKFSPage, loading, lenderId, showErrorModal, closeErrorModal, errorTitle, errorDesc }) => {
    const [showToolTip, setShowToolTip] = useState(false);
    const [showExistingCLToolTip, setShowExistingCLToolTip] = useState(false);
    const renderInterestAndChargesCard = () => {
        return (React.createElement(View, { style: { height: 300, paddingTop: 24, paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(Typography, { label: "Interest and charges", typeDLS: TypographyTypeDLS.H3S }),
            React.createElement(View, { style: { marginTop: 24, borderWidth: 1, borderColor: "#E4E7EC", height: 142, padding: 12, borderRadius: 12 } },
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12 } },
                    React.createElement(Typography, { label: "Processing fee (excl. of GST)", typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: `₹${pledgeDetails?.stepResponseObject?.processingFeesBreakUp['Processing Fee']}`, typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: "#E4E7EC" } }),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12, marginTop: 12 } },
                    React.createElement(Typography, { label: "Stamp duty fee", typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: `₹${pledgeDetails?.stepResponseObject?.processingFeesBreakUp['Stamp Duty (as per reg. state)*']}`, typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: "#E4E7EC" } }),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 12 } },
                    React.createElement(Typography, { label: "Total", typeDLS: TypographyTypeDLS.B0S }),
                    React.createElement(Typography, { label: `₹${pledgeDetails.stepResponseObject.processingFees}`, typeDLS: TypographyTypeDLS.B0M }))),
            React.createElement(View, { style: { marginTop: 24, marginBottom: 16 } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setShowToolTip(false);
                    } }))));
    };
    const renderInterestAndChargesBottomCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 300, width: '100%', closeFunction: () => {
                    setShowToolTip(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, renderInterestAndChargesCard())));
    };
    const handleCloseErrorModal = async () => {
        await triggerAction(closeErrorModal);
    };
    const renderErrorModal = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1, alignItems: 'center', flex: 1, }, activeOpacity: 1 },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: errorTitle, typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    marginTop: 8,
                    backgroundColor: '#FEF4E6',
                    width: '100%',
                    padding: 16,
                    marginBottom: 24,
                    borderRadius: 8,
                } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: errorDesc, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    paddingBottom: 8,
                    marginBottom: 4,
                } },
                React.createElement(Button, { id: 'bt_removePledge_continueUnpledge', type: ButtonTypeTokens.LargeSoftFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, label: 'Ok, got it!', width: ButtonWidthTypeToken.FULL, onPress: handleCloseErrorModal }))));
    };
    const renderErrorBottomModal = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobileView() ? 260 : 240, width: '100%', closeFunction: handleCloseErrorModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, renderErrorModal())));
    };
    return (React.createElement(View, { style: { height: height, marginHorizontal: -16 } },
        React.createElement(CustomHeader, { title: "Verify interests and charges", needHelpId: "btn_verifyInterestEnhanceLimit_needHelp", goBackId: "btn_verifyInterestEnhanceLimit_goBack", goBackAction: goBackAction, needHelpAction: needHelpAction, triggerAction: triggerAction }),
        React.createElement(ScrollView, { style: {
                height: Platform.OS === 'web' ? height - 44 : height - 200,
                paddingBottom: Platform.OS !== "web" ? Platform.OS === "ios" ? 280 : 350 : 120,
                backgroundColor: "#E7EBFA",
            }, scrollEnabled: true, nestedScrollEnabled: true },
            React.createElement(TouchableOpacity, { onPress: () => {
                    setShowToolTip(false);
                    setShowExistingCLToolTip(false);
                }, activeOpacity: 1 },
                React.createElement(View, { style: {
                        marginTop: 24,
                        padding: 16,
                        backgroundColor: 'white',
                        borderColor: '#E4E7EC',
                        borderWidth: 1,
                    } },
                    React.createElement(Typography, { label: "Selected credit limit", typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { marginTop: 6, marginBottom: 16 } },
                        React.createElement(Typography, { label: `₹${addCommasToNumber(pledgeDetails?.stepResponseObject?.requestCreditLimit)}`, fontSize: FontSizeTokens.XXL, fontWeight: "700", lineHeight: 32, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Secondary_100 })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(Typography, { label: "Selected mutual funds", typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: { marginTop: 2 } },
                            React.createElement(Typography, { label: `₹${addCommasToNumber(pledgeDetails?.stepResponseObject?.requestedPortfolioValue)}`, fontSize: FontSizeTokens.MD, lineHeight: 24, fontWeight: "700", color: ColorTokens.Grey_Night })))),
                React.createElement(View, { style: { marginTop: 24, marginBottom: 8, paddingHorizontal: 16 } },
                    React.createElement(Typography, { label: "Updated credit limit", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { backgroundColor: 'white', borderColor: '#E4E7EC', borderWidth: 1, padding: 16 } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(TouchableOpacity, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' }, onPress: () => {
                                setShowExistingCLToolTip(!showExistingCLToolTip);
                            } },
                            React.createElement(Typography, { label: "Existing credit limit", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                            React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.SM, color: ColorTokens.Grey_Smoke })),
                            showExistingCLToolTip &&
                                React.createElement(TooltipComp, { title: "Existing credit limit is based on the latest value of your pledged mutual funds", leftShiftContent: -60, tooltipContainerBottomPosition: 20, tooltipArrowLeftPosition: -15, tooltipArrowBottomPosition: 12 })),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(pledgeDetails?.stepResponseObject?.existingDrawingPower)}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Secondary_100 })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginTop: 16,
                            marginBottom: 16
                        } },
                        React.createElement(Typography, { label: "Additional credit limit", typeDLS: TypographyTypeDLS.B1R }),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(pledgeDetails?.stepResponseObject?.requestCreditLimit)}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Secondary_100 })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: { paddingTop: 16 } },
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Typography, { label: "Total credit limit", typeDLS: TypographyTypeDLS.B1B }),
                            React.createElement(Typography, { label: `₹${addCommasToNumber(pledgeDetails?.stepResponseObject?.drawingPower)}`, typeDLS: TypographyTypeDLS.B1B, color: ColorTokens.Secondary_100 })))),
                React.createElement(View, { style: { marginTop: 24, marginBottom: 8, paddingHorizontal: 16 } },
                    React.createElement(Typography, { label: "Interest and charges", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { padding: 16, backgroundColor: 'white', borderColor: '#E4E7EC', borderWidth: 1 } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingBottom: 16 } },
                        React.createElement(Typography, { label: "Interest rate", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: `${pledgeDetails.stepResponseObject.interestRate}%`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: { paddingTop: 16, flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(TouchableOpacity, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' }, onPress: () => {
                                setShowToolTip(!showToolTip);
                            } },
                            React.createElement(Typography, { label: "Total charges", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                            React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.SM, color: ColorTokens.Grey_Smoke }))),
                        React.createElement(Typography, { label: `₹${pledgeDetails.stepResponseObject.processingFees}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: { marginTop: 24, marginBottom: 8, paddingHorizontal: 16 } },
                    React.createElement(Typography, { label: "Repayment schedule", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: {
                        padding: 16,
                        backgroundColor: 'white',
                        borderColor: '#E4E7EC',
                        borderWidth: 1,
                        marginBottom: 24
                    } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingBottom: 16 } },
                        React.createElement(Typography, { label: "Loan expires on", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: `${loanExpireDateToShow}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: {
                            paddingTop: 16,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingBottom: 16
                        } },
                        React.createElement(Typography, { label: "Interest autopay", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: `${getAutoDebitDate(autoDebitDate)}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: lenderId === "TATA" ? { paddingTop: 16, flexDirection: 'row', justifyContent: 'space-between' } : { paddingTop: 16, flexDirection: 'row', justifyContent: 'space-between', ...Platform.OS === "ios" && {
                                paddingBottom: 90
                            } } },
                        React.createElement(Typography, { label: "Principal repayment", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: "Flexible", typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }))),
                lenderId === "Tata" &&
                    React.createElement(View, { style: {
                            marginTop: 24,
                            padding: 16,
                            justifyContent: 'space-between',
                            backgroundColor: 'white',
                            flexDirection: 'row',
                            ...Platform.OS !== "web" && {
                                paddingBottom: 120
                            },
                            ...Platform.OS === "ios" && {
                                marginBottom: 24
                            }
                        } },
                        React.createElement(Typography, { label: "For Key fact statement", typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                triggerAction({
                                    ...openKFSPage
                                });
                            } },
                            React.createElement(Typography, { label: "Click here", typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 }))),
                Platform.OS === 'android' && React.createElement(View, { style: { height: 100 } }))),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                padding: 16,
                backgroundColor: 'white',
                marginTop: 24,
                width: '100%',
                ...Platform.OS === "ios" && {
                    paddingBottom: 28
                }
            } },
            React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Confirm & proceed", onPress: () => {
                    triggerAction({
                        ...continueAction,
                        payload: {
                            value: pledgeDetails.stepResponseObject,
                            isResend: false,
                        }
                    });
                }, loading: loading }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    marginTop: 8
                } },
                React.createElement(View, { style: { marginRight: 9 } },
                    React.createElement(Typography, { label: 'LENDING PARTNER', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '400', color: ColorTokens.Grey_Charcoal, lineHeight: 16 })),
                lenderData?.lenderAccountId.toLowerCase() === LENDER_ID.DSP ?
                    React.createElement(View, { style: { marginLeft: -62 } },
                        React.createElement(Icon, { name: getLenderIcon(lenderData?.lenderAccountId) }))
                    :
                        React.createElement(Icon, { name: getLenderIcon(lenderData?.lenderAccountId) }))),
        showToolTip && renderInterestAndChargesBottomCard(),
        showErrorModal && renderErrorBottomModal()));
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 36
    },
    marginTop4: {
        marginTop: 4
    },
    insideContainer: {
        justifyContent: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        flex: 1
    },
    marginTop16: {
        marginTop: 16
    },
    bottomStack: {
        bottom: 0,
        position: 'absolute',
        justifyContent: 'center',
        flexDirection: 'row',
        alignSelf: 'center',
        marginBottom: 24,
        alignItems: 'center',
        alignContent: 'center'
    },
    marginLeft4: {
        marginLeft: 4
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#FFFFFF',
        color: 'white',
        padding: 10,
        borderRadius: 8,
        width: 233,
        bottom: '100%',
        left: '50%',
        shadowColor: '#98A2B3',
        zIndex: 1,
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.20,
        shadowRadius: 4.65,
        marginBottom: 2
    },
});
// @ts-ignore
export default (VerifyInterestEnhanceLimit);
